import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54e74580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "file" }
const _hoisted_2 = {
  key: 0,
  class: "form-view pc-wrap"
}
const _hoisted_3 = { class: "table-top pt10 pb10" }
const _hoisted_4 = { class: "flex-a-center" }
const _hoisted_5 = { class: "table-box" }
const _hoisted_6 = { class: "flex-column-center" }
const _hoisted_7 = { class: "b-num" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex-column-center" }
const _hoisted_10 = { class: "b-num" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "flex-c-center pt20 pb20"
}
const _hoisted_13 = ["src"]

import { ref, defineAsyncComponent, onMounted, computed } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import {CaretBottom, Search} from '@element-plus/icons-vue'
import { fileListApi, fileDelApi, fileStatusApi } from '@/api/file'
import checkPc from '@/utils/checkPc'
import { useUser } from '@/composable/useUser'
import {formatTimeSelf} from "@/utils/formatDateTime";
import { useCheckFileOptionsAuth } from '@/utils/checkFileOptionsAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { checkAuth, handleVipTip } = useUser()

/**
 * 判断是否PC端
 */
const isPC = checkPc()

// 引入组件
const MainTitle = defineAsyncComponent(() => import("@/views/member/components/MainTitle.vue"));
const SetFile = defineAsyncComponent(() => import("@/views/member/file/components/SetFile.vue"));
const ViewVisitors = defineAsyncComponent(() => import("@/views/member/file/components/ViewVisitors.vue"));
const ViewTrack = defineAsyncComponent(() => import("@/views/member/file/components/ViewTrack.vue"));
const FileRename = defineAsyncComponent(() => import("@/views/member/file/components/FileRename.vue"));
const Replace = defineAsyncComponent(() => import("@/views/member/file/components/Replace.vue"));
const CopyLink = defineAsyncComponent(() => import("@/views/member/file/components/CopyLink.vue"));
const DownTips = defineAsyncComponent(() => import("@/views/member/file/components/DownTips.vue"));
const PhoneFile = defineAsyncComponent(() => import("@/views/member/file/components/phone/PhoneFile.vue"));

const checkAuthInfo = useCheckFileOptionsAuth();
const {checkFileOptionsAuth} = checkAuthInfo;

// 设置
const setFileRef = ref()
const toSet = async (item: any) => {
  const status = await checkFileOptionsAuth('setbutton');
  if (!status) return
  setFileRef.value.openDialog(item)
}

// 查看访客
const viewVisitorsRef = ref()
const toVisitor = async (item: any) => {
  const status = await handleVipTip('visitor_trajectory')
  if (!status) return
  viewVisitorsRef.value.openDialog(item)
}

// 查看轨迹
const viewTrackRef = ref()
const toTrack = async (item: any) => {
  const status = await handleVipTip('visitor_trajectory')
  if (!status) return
  viewTrackRef.value.openDialog(item)
}

// 复制链接
const copyLinkRef = ref()
const toCopyLink = async (item: any) => {  
  const status = await checkFileOptionsAuth('cobybutton');
  if (!status) return
  copyLinkRef.value.openDialog(item)
}

// 重命名
const fileRenameRef = ref()
const toRename = async (item: any) => {
  const status = await checkFileOptionsAuth('renamebutton');
  if (!status) return
  fileRenameRef.value.openDialog(item)
}

// 替换
const replaceRef = ref();
const toReplace = async (item: any) => {
  const status = await checkFileOptionsAuth('replacebutton');
  if (!status) return
  replaceRef.value.openDialog(item)
}

// 下载地址
const toDownloadUrl = computed(() => {
  return process.env.VUE_APP_PROXY_DOMAIN + '/Filemanage/downfile'
});

const downloadUrl = ref<string>('')

const downloadVisible = ref<boolean>(false)

// 下载
const toDownload = (item: any) => {
  // window.open(`${toDownloadUrl.value}?url=${item.url}`, '_blank')
  // window.open(`${toDownloadUrl.value}?url=${item.url}`, '_blank')
  downloadVisible.value = true;
  downloadUrl.value = item.url;
}

// 预览
const toView = async (item: any) => {
  const status = await checkFileOptionsAuth('previewbutton');
  if (!status) return
  window.open(item.share_url, '_blank')
}

// 设置下架提示语
const downTipsRef = ref();
const toDownTips = async (item: any) => {
  const status = await checkFileOptionsAuth('hintbutton');
  if (!status) return
  downTipsRef.value.openDialog(item)
}

/**
 * 加载中
 */
const loading = ref<boolean>(false);

/**
 * 文件列表处理
 */
const tableData = ref<any>([])
const tableParams = ref({ limit: 15, page: 1, title: '' })
const tableTotal = ref(0)
// 获取文件列表
const getFileList = async () => {
  loading.value = true;
  const res: any = await fileListApi(tableParams.value)
  if (res){
    loading.value = false;
  }
  // console.log(res)
  tableData.value = res.data
  tableTotal.value = res.total
}

/* 表格数据多选处理 */
const multipleTableRef = ref()
const multipleSelection = ref([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

/**
 * 删除处理
 */
// 批量删除
const delBtn = async () => {
  const auth = await checkFileOptionsAuth('remote_destruction');
  if (!auth) return
  /* let status = await handleVipTip('remote_destruction')
  if (!status) return */
  let data = multipleSelection.value
  if (data.length == 0) {
    ElMessage.error('请选择需要删除的数据')
  } else {
    let ids = data.map((item: any) => item.id)
    // console.log(ids)
    toDelete(ids.toString())
  }
}

// 删除接口
const toDelete = async (ids: any) => {
  const auth = await checkFileOptionsAuth('remote_destruction');
  if (!auth) return

  /* let status = await handleVipTip('remote_destruction')
  if (!status) return */
  try {
    await ElMessageBox.confirm('该操作会删除当前数据', '确定要删除数据吗?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    })
    await fileDelApi({ id: ids })
    ElMessage.success('删除成功')
    getFileList()
  } catch (error) {

  }
}

/**
 * 上下架处理
 */
// 批量上下架
const changeStatusBtn = async (type: any) => {
  const auth = await checkFileOptionsAuth('unmountbutton');
  if (!auth) return

  let tips = '操作', status
  switch (type) {
    case 'up':
      tips = '上架'
      status = '0'
      break
    case 'down':
      tips = '下架'
      status = '1'
      break
  }
  let data = multipleSelection.value
  if (data.length == 0) {
    ElMessage.error(`请选择需要${tips}的数据`)
  } else {
    let ids = data.map((item: any) => item.id)
    // console.log(ids)
    changeStatus({ id: ids.toString(), status })
  }
}

// 改变状态
const changeStatus = async (row: any) => {
  const auth = await checkFileOptionsAuth('unmountbutton');
  if (!auth) return

  let status = row.status == '0' ? '1' : '0'
  const res = await fileStatusApi({ id: row.id, status })
  ElMessage.success('操作成功')
  await getFileList()
}

/**
 * 非会员操作提示
 */
const toSearch = async () => {
  let status = await handleVipTip('file_search', true)
  if (!status) return
  tableParams.value.page = 1
  getFileList()
}

onMounted(() => {
  getFileList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isPC))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(MainTitle), null, {
            default: _withCtx(() => [
              _createTextVNode("文件管理")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form, { inline: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeStatusBtn('up')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量上架")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      color: "#6F95D5",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeStatusBtn('down')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量下架")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      color: "#717171",
                      onClick: delBtn
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("批量删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_input, {
                        modelValue: tableParams.value.title,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tableParams.value.title) = $event)),
                        placeholder: "请输入标题",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: toSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("搜索")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_table, {
              ref_key: "multipleTableRef",
              ref: multipleTableRef,
              data: tableData.value,
              style: {"width":"100%"},
              height: "calc(100vh - 0.84rem - 200px)",
              size: "default",
              onSelectionChange: handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "title",
                  label: "文档名称",
                  align: "center",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "文档ID",
                  align: "center",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(" ID" + _toDisplayString(row.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createtime",
                  label: "创建时间",
                  width: "200",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "sctime",
                  label: "失效时间",
                  align: "center",
                  width: "200"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.sctime && scope.row.sctime != '0' ? _unref(formatTimeSelf)(scope.row.sctime) : '永久'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "pageview",
                  label: "浏览人数",
                  align: "center",
                  width: "120"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(scope.row.pageview), 1),
                      _createElementVNode("div", {
                        class: "b-text cursor-pointer",
                        onClick: ($event: any) => (toVisitor(scope.row))
                      }, "查看访客", 8, _hoisted_8)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "viewcount",
                  label: "浏览次数",
                  align: "center",
                  width: "120"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(scope.row.viewcount), 1),
                      _createElementVNode("div", {
                        class: "b-text cursor-pointer",
                        onClick: ($event: any) => (toTrack(scope.row))
                      }, "查看轨迹", 8, _hoisted_11)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "status",
                  label: "上下架",
                  align: "center",
                  width: "120"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_switch, {
                      "model-value": scope.row.status,
                      "active-value": "1",
                      "inactive-value": "0",
                      style: {"--el-switch-on-color":"#FF7B6D"},
                      onClick: ($event: any) => (changeStatus(scope.row))
                    }, null, 8, ["model-value", "onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "action",
                  label: "操作",
                  align: "center",
                  width: "150"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toSet(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("设置")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toCopyLink(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("复制链接")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toRename(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("重命名")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toReplace(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("替换")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toView(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("预览")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toDownTips(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下架提示")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: ($event: any) => (toDelete(scope.row.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { color: "#fff" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 查看"),
                            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CaretBottom))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            (tableTotal.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    layout: "total, prev, pager, next, jumper",
                    "current-page": tableParams.value.page,
                    "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((tableParams.value.page) = $event)),
                    "page-size": tableParams.value.limit,
                    "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((tableParams.value.limit) = $event)),
                    total: tableTotal.value,
                    onCurrentChange: getFileList
                  }, null, 8, ["current-page", "page-size", "total"])
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, loading.value]
          ]),
          _createVNode(_unref(ViewVisitors), {
            ref_key: "viewVisitorsRef",
            ref: viewVisitorsRef
          }, null, 512),
          _createVNode(_unref(ViewTrack), {
            ref_key: "viewTrackRef",
            ref: viewTrackRef
          }, null, 512),
          _createVNode(_unref(SetFile), {
            ref_key: "setFileRef",
            ref: setFileRef,
            onSuccess: getFileList
          }, null, 512),
          _createVNode(_unref(CopyLink), {
            ref_key: "copyLinkRef",
            ref: copyLinkRef
          }, null, 512),
          _createVNode(_unref(FileRename), {
            ref_key: "fileRenameRef",
            ref: fileRenameRef,
            onSuccess: getFileList
          }, null, 512),
          _createVNode(_unref(Replace), {
            ref_key: "replaceRef",
            ref: replaceRef,
            onSuccess: getFileList
          }, null, 512),
          _createVNode(_unref(DownTips), {
            ref_key: "downTipsRef",
            ref: downTipsRef,
            onSuccess: getFileList
          }, null, 512),
          _createVNode(_component_el_dialog, {
            modelValue: downloadVisible.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((downloadVisible).value = $event)),
            title: "下载",
            fullscreen: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("iframe", {
                src: downloadUrl.value,
                frameborder: "0",
                style: {"width":"100%","height":"600px"}
              }, null, 8, _hoisted_13)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createBlock(_unref(PhoneFile), {
          key: 1,
          data: tableData.value,
          onRefresh: getFileList,
          onSearch: toSearch
        }, {
          search: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: tableParams.value.title,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tableParams.value.title) = $event)),
              placeholder: "请输入标题",
              "prefix-icon": _unref(Search),
              clearable: "",
              onChange: toSearch
            }, null, 8, ["modelValue", "prefix-icon"])
          ]),
          pagination: _withCtx(() => [
            _createVNode(_component_el_pagination, {
              "hide-on-single-page": true,
              background: "",
              layout: "prev, next",
              "current-page": tableParams.value.page,
              "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((tableParams.value.page) = $event)),
              "page-size": tableParams.value.limit,
              "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((tableParams.value.limit) = $event)),
              total: tableTotal.value,
              onCurrentChange: getFileList
            }, null, 8, ["current-page", "page-size", "total"])
          ]),
          _: 1
        }, 8, ["data"]))
  ]))
}
}

})